import qs from "qs";
import {
  ID_FILTER_DEALERS,
  ID_FILTER_LEGAL_ENTITIES,
  ID_FILTER_REPORT_CREATIONDATEFROM,
  ID_FILTER_REPORT_CREATIONDATETO,
} from "../../pages/intermediaries/constants/IntermediariesFilters";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import dayjs from "dayjs";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useIntermediariesReportRepository = () => {
  const { GET, POST, DELETE } = useApi();

  const PATH = "/finance/intermediaries";

  const {
    globalData: { user },
  } = useContext(GlobalContext);
  const allLegalEntities: any[] = user.legalEntities
    ?.filter((x: any) => x.name.toLowerCase() !== "all")
    .map((x: any) => x.name);

  function getReports(
    offset: number,
    limit: number,
    sort: string | null,
    order: string | null,
    filterDefs: FilterDef[] = []
  ): Promise<HTTPGenericResponse> {
    let createdDateFrom: Date = getFilterValue(
      ID_FILTER_REPORT_CREATIONDATEFROM,
      filterDefs
    );
    let createdDateTo: Date = getFilterValue(
      ID_FILTER_REPORT_CREATIONDATETO,
      filterDefs
    );
    let legalEntities: string[] =
      getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
    let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

    let params = {
      offset: offset,
      limit: limit,
      sort: sort,
      order: order,
      createdDateFrom: createdDateFrom
        ? dayjs(createdDateFrom).toISOString()
        : null,
      createdDateTo: createdDateTo ? dayjs(createdDateTo).toISOString() : null,
      legalEntities,
      dealers,
    };

    return GET(`${PATH}/intermediaryPrintout/report`, {
      params: params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });
  }

  function getReportById(id: string): Promise<HTTPGenericResponse> {
    let params = {
      legalEntities: allLegalEntities,
    };

    return GET(`${PATH}/intermediaryPrintout/report/single?id=${id}`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });
  }

  function postPrintoutRequest(
    printoutRequest: any
  ): Promise<HTTPGenericResponse> {
    return POST(
      `${PATH}/intermediaryPrintout/create/report`,
      printoutRequest,
      {},
      true
    );
  }

  function deleteIntermediaryPrintoutReport(id: string) {
    let params = { id: id };
    return DELETE(
      `${PATH}/intermediaryPrintout/report`,
      { params: params },
      true
    );
  }

  return {
    getReports,
    getReportById,
    postPrintoutRequest,
    deleteIntermediaryPrintoutReport,
  };
};
